import { AppBar, Toolbar } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { logSetAmounts } from '../../../model/events';
import ProductWizardState from '../../../model/ProductWizardState';
import Screen from '../../ProductWizard/Screen';
import { ProductWizardTransLink } from '../../ProductWizardTransLink/ProductWizardTransLink';
import { Button, Typography } from 'ui-components';

import useStyles from './CartQuantityBar.style';

const CartQuantityBar:FunctionComponent<{
  source: Screen
}> = ({source}) => {
  const [t] = useTranslation('cart');
  const c = useStyles({});
  const quantity = useSelector((state: ProductWizardState) => state.cartState.cartFunds.length);

  const bar =
    <AppBar position="fixed" color="primary" className={c.appBar}>
      <Toolbar>
        <div className={c.container}>
          <div className={c.spacer}></div>
          <div className={c.quantityWrapper}>
            <Typography textColor="greys.60" className={c.quantityTitle}>
              {t('number-of-selected-funds', 'Number of selected funds')}
            </Typography>
            <Typography variant="subHeadline2" component="p" fontWeight="bold">
              {quantity}
            </Typography>
          </div>
          <div className={c.spacer}></div>
          <ProductWizardTransLink
            path={Screen.SET_AMOUNTS_PER_FUND.code}
            onClick={() => logSetAmounts(source)}
            className={c.nextButton}
          >
            <Button
              accent={true}
              className={c.nextButton}
            >
              {t('next', 'Next')}
            </Button>
          </ProductWizardTransLink>
        </div>
      </Toolbar>
    </AppBar>

  return quantity ? bar : null;
};

export default CartQuantityBar;
